/**
 * AirplaneIllustration/index.js
 * desc: airplane image
 * note: stateless presentational component
 */
'use strict';

import { classNames } from '../../../utilities';
import './styles.css';


const AirplaneIllustration = ({ className }) => {
    const classList = classNames('airplane illustration', className);

    return (
        <figure className={ classList } >
            <svg viewBox="0 0 37 23" xmlns="http://www.w3.org/2000/svg"><path d="M1.099 1.603L35.49 8.168 14.376 21.892l-2.856-4.797L2.1 18.163l4.48-9.776L1.1 1.603z" /><path d="M35.492 8.168L1.099 1.603 6.58 8.387m28.91-.22L14.376 21.893l-2.856-4.797m23.973-8.927L8.663 12.299m26.829-4.131l-28.911.22m0 0L2.1 18.162m0 0l6.563-5.864M2.1 18.163l9.419-1.068M8.663 12.3l2.856 4.796" /></svg>
        </figure>
    );
};


export default AirplaneIllustration;
